import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const UpdatePassword = () => {
  const { metadata } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [userData, setUserData] = useState({
    secuenciaPersonal: '',
    codigoUsuario: '',
    fechaLimite: '',
    nombre: ''
  });

  useEffect(() => {
    try {
      if (metadata) {
        const decoded = atob(metadata);
        const parsed = JSON.parse(decoded);
        setUserData(parsed);
      }
    } catch (error) {
      console.error('Error decodificando metadata:', error);
    }
  }, [metadata]);

  const hasLetter = /[A-Za-z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecial = /[!@#$%^&*(),.?":{}|<>_\-]/.test(password);
  const isValid = password.length >= 8 && hasLetter && hasNumber && hasSpecial;
  const passwordsMatch = password === confirmPassword && confirmPassword.length > 0;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValid || !passwordsMatch) return;

    setLoading(true);
    setMessage('');

    try {
      const passwordBase64 = btoa(password);

      const response = await fetch(
        'https://analitica.phantomx.com.ec/analitica/v1/portal_bi/seguridad/cambiar_contrasenia',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Application: 'UEhBTlRPTVhfREJJ',
            IdOrganizacion: '365509c8-9596-4506-a5b3-487782d5876e',
          },
          body: JSON.stringify({
            codigoUsuario: userData.codigoUsuario,
            password: passwordBase64
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setMessage('Contraseña actualizada correctamente.');
        setTimeout(() => navigate('/login'), 3000);
      } else {
        setMessage(data.message || 'Error al actualizar la contraseña.');
      }
    } catch (error) {
      console.error(error);
      setMessage('Error de conexión con el servidor.');
    } finally {
      setLoading(false);
    }
  };

  // Estilo del input con icono
  const inputContainerStyle = {
    position: 'relative',
    marginBottom: 20,
  };

  const inputStyle = {
    width: '100%',
    padding: '10px 40px 10px 10px',
    borderRadius: 4,
    border: '1px solid #ccc',
    marginTop: 5,
    boxSizing: 'border-box',
  };

  const eyeStyle = {
    position: 'absolute',
    right: 10,
    top: '70%', // bajamos un poquito el botón
    transform: 'translateY(-50%)',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: 0,
    fontSize: 18,
    color: '#555',
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f0f4f8',
        padding: 20,
      }}
    >
      <div
        style={{
          maxWidth: 400,
          width: '100%',
          background: '#fff',
          padding: 30,
          borderRadius: 10,
          boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
        }}
      >
        <h2 style={{ textAlign: 'center', marginBottom: 15 }}>Actualizar contraseña</h2>

        <p style={{ textAlign: 'center', marginBottom: 5 }}>
          Usuario: <strong>{userData.nombre}</strong>
        </p>
        <p style={{ textAlign: 'center', marginBottom: 20 }}>
          Código: <strong>{userData.codigoUsuario}</strong>
        </p>

        <form onSubmit={handleSubmit}>
          {/* Input contraseña */}
          <div style={inputContainerStyle}>
            <label>Contraseña nueva</label>
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingresa tu nueva contraseña"
              style={inputStyle}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={eyeStyle}
            >
              {showPassword ? '✖️' : '👁️'}
            </button>
          </div>

          {/* Input confirmar contraseña */}
          <div style={inputContainerStyle}>
            <label>Confirmar contraseña</label>
            <input
              type={showConfirm ? 'text' : 'password'}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Vuelve a ingresar la contraseña"
              style={inputStyle}
              required
            />
            <button
              type="button"
              onClick={() => setShowConfirm(!showConfirm)}
              style={eyeStyle}
            >
              {showConfirm ? '✖️' : '👁️'}
            </button>
          </div>

          {/* Validaciones */}
          <div style={{ fontSize: 14, marginBottom: 15 }}>
            <p style={{ color: hasLetter ? 'green' : 'red' }}>• Contiene al menos una letra</p>
            <p style={{ color: hasNumber ? 'green' : 'red' }}>• Contiene al menos un número</p>
            <p style={{ color: hasSpecial ? 'green' : 'red' }}>
              • Contiene al menos un carácter especial (!@#$%... o _ -)
            </p>
            <p style={{ color: password.length >= 8 ? 'green' : 'red' }}>• Mínimo 8 caracteres</p>
            <p style={{ color: passwordsMatch ? 'green' : 'red' }}>
              • Las contraseñas coinciden
            </p>
          </div>

          <button
            type="submit"
            disabled={!isValid || !passwordsMatch || loading}
            style={{
              width: '100%',
              padding: 12,
              borderRadius: 6,
              backgroundColor: isValid && passwordsMatch ? '#007bff' : '#ccc',
              color: '#fff',
              border: 'none',
              fontWeight: 'bold',
              cursor: isValid && passwordsMatch ? 'pointer' : 'not-allowed',
              fontSize: 16,
            }}
          >
            {loading ? 'Actualizando...' : 'Aceptar'}
          </button>
        </form>

        {message && (
          <p style={{ textAlign: 'center', marginTop: 15, color: '#333' }}>{message}</p>
        )}
      </div>
    </div>
  );
};

export default UpdatePassword;
